import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Launch } from 'src/models/launch.model';
import { tap } from 'rxjs/operators';
import { DateUtil } from 'src/app/shared/utils/date.util';

const API_URL = `${environment.api.baseUrl || ""}${environment.api.services.launch}`;

@Injectable({
  providedIn: 'root'
})
export class LaunchService {

  constructor(private httpClient: HttpClient) { }

  /**
   * 
   * @param launchId 
   * @returns 
   */
  getLaunch(launchId: string = "") {
    return this.httpClient.get<Launch>(API_URL, {
      params: { "launchId": launchId },
    }).pipe(
      tap((launch: Launch) => {
        // convert utc to user timezone
        if (launch.startDate) {
          launch.startDate = DateUtil.toISOString(new Date(launch.startDate))
        }
        // convert utc to user timezone
        if (launch.endDate) {
          launch.endDate = DateUtil.toISOString(new Date(launch.endDate))
        }
      })
    );

  }
}
